import { FC } from 'react';
import { Link } from 'react-router-dom';
// Import UI components
import { Button } from '@geneui/components';
// Import Types
import type { IButtonProps } from '@geneui/components/lib/atoms/Button';

enum MouseButton {
    Left = 0,
    Middle = 1,
    Right = 2,
}

interface ActionLinkProps extends IButtonProps {
    withConfirm?: boolean;
    redirectPath: string;
    onRedirect?: () => void;
}

const ActionLink: FC<ActionLinkProps> = ({
    icon,
    appearance,
    color,
    onClick,
    withConfirm,
    redirectPath,
    onRedirect,
}) => {
    const buttonClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (e.button === MouseButton.Right) {
            return;
        }

        if (e.button === MouseButton.Middle) {
            e.preventDefault();
        }

        onClick?.(e);
    };
    const linkClickHandler = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (e.button === MouseButton.Left && !e.ctrlKey) {
            onRedirect?.();
        }
    };

    return withConfirm ? (
        <Button icon={icon} appearance={appearance} color={color} onMouseDown={buttonClickHandler} />
    ) : (
        <Link to={redirectPath} onClick={linkClickHandler}>
            <Button icon={icon} appearance={appearance} color={color} />
        </Link>
    );
};

export default ActionLink;
